import angular from 'angular';
import 'ng-tags-input/build/ng-tags-input.min.js';
import 'ng-tags-input/build/ng-tags-input.min.css';

import 'angular-animate';
import 'angular-cookies';
import 'angular-file-upload';
import 'angular-filter';
import 'angular-loading-bar';
import 'angular-local-storage';
import 'angular-multi-select-tree/dist/angular-multi-select-tree-0.1.0';
import 'angular-permission';
import 'angular-sanitize';
import 'angular-touch';
import 'angular-translate';
import 'angular-translate-loader-static-files';
import 'angular-ui-bootstrap';
import 'angular-ui-mask';
import 'angular-ui-router';
import 'ui-select';
import 'angular-chart.js';
import 'ng-idle';
import 'angular-i18n/angular-locale_pt-br.js';

import './app.configs.module';
import './app.constants.module';
import './app.controllers.module';
import './app.directives.module';
import './app.filters.module';
import './app.models.module';
import './app.runners.module';
import './app.services.module';

const module = 'app';

const requires = [
  'angular-loading-bar',
  'angular.filter',
  'angularFileUpload',
  'LocalStorageModule',
  'multi-select-tree',
  'ngAnimate',
  'ngCookies',
  'ngIdle',
  'ngSanitize',
  'ngTouch',
  'pascalprecht.translate',
  'permission.ui',
  'permission',
  'ui.bootstrap',
  'ui.mask',
  'ui.router',
  'ui.select',
  'chart.js',
  'app.constants',
  'app.configs',
  'app.directives',
  'app.filters',
  'app.models',
  'app.services',
  'app.controllers',
  'app.runners',
  'ngTagsInput',
];

angular.module(module, requires);